import _ from 'lodash';
import { useEffect } from 'react';
import api from '~/services/api';
import useGlobalContext from '~/view-data/use-global-context';
import useHeader from './use-header';
import { showMessage } from '~/helper';

const initialState = {
  loading: false,
  showCovidModal: false,
  model: {},
};

const useMatchDay = () => {
  const { state: { matchDay = initialState }, dispatch } = useGlobalContext();
  const { actions: headerActions } = useHeader();

  const loadRoles = async () => {
    try {
      const { data } = await api.get(`match-day/roles`);
      dispatch({ type: 'matchDay', payload: { roles: data } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  useEffect(() => {
    (async () => await loadRoles())();
    return () => {
      dispatch({ type: 'matchDay', payload: { model: {}, loading: false } });
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    headerActions.configure({
      title: 'Match Day',
      loading: _.get(matchDay, 'loading', false)
    });
    // eslint-disable-next-line
  }, [matchDay]);

  const selectEvent = (event) => {
    dispatch({ type: 'matchDay', payload: { model: { event } } });
  };

  const newEmployee = () => {
    dispatch({
      type: 'matchDay',
      payload: { model: { ...matchDay.model, employee: { isNew: true } } },
    });
  };

  const selectEmployee = async (person = {}) => {
    try {
      dispatch({ type: 'matchDay', payload: { loading: true } });

      const personId = _.get(person, 'id');
      const eventId = _.get(matchDay, 'model.event.id');
      let employee = {};

      if (personId && eventId) {
        const { data } = await api.get(`match-day/employee-load`, {
          params: { eventId, personId },
        });
        employee = data;
      }

      dispatch({
        type: 'matchDay',
        payload: { model: { ...matchDay.model, employee }, loading: false },
      });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const selectCompany = (values, company = {}) => {
    const newValues = _.cloneDeep(values);
    newValues.employee.company = company;
    dispatch({ type: 'matchDay', payload: { model: newValues } });
  };

  const eventsFinding = async (term, callback) => {
    try {
      const { data } = await api.get(`match-day/events-finding`, { params: { term } });
      callback(data);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const employeesFinding = async (term, callback) => {
    try {
      const { data } = await api.get(`match-day/employees-finding`, { params: { term } });
      callback(data);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const companiesFinding = async (term, callback) => {
    try {
      const { data } = await api.get(`match-day/companies-finding`, { params: { term } });
      callback(data);
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const isSelectedEvent = () => {
    const event = _.get(matchDay, 'model.event');
    return !_.isEmpty(event);
  };

  const isSelectedEmployee = () => {
    const employee = _.get(matchDay, 'model.employee');
    return !_.isEmpty(employee);
  };
  
  const hasPCovid = () => {
    const vaccinationCertificate = _.get(matchDay, 'model.employee.person.vaccinationCertificate');
    const checkUpPCR = _.get(matchDay, 'model.employee.person.checkUpPCR');
    return vaccinationCertificate || checkUpPCR
  };

  const isAddMode = () => {
    return _.get(matchDay, 'model.employee.isNew') || false;
  };

  const failure = (error) => {
    dispatch({ type: 'matchDay', payload: { loading: false } });
    showMessage('error', error);
  };

  const saveEmployee = async (kind, values) => {
    try {
      dispatch({ type: 'matchDay', payload: { loading: true } });
      const person = _.omit(_.get(values, 'employee.person'), ['photo', 'vaccinationCertificate', 'checkUpPCR']);
      _.set(values, 'employee.person', person);
      await api.post('match-day/save', { ...values, kind });
      showMessage('success', 'Colaborador salvo com sucesso!');
      selectEmployee({});
    } catch (error) {
      failure(error, dispatch);
    } finally {
      dispatch({ type: 'matchDay', payload: { loading: false } });
    }
  };

  const searchByCredentialNumber = async (value) => {
    try {
      dispatch({ type: 'matchDay', payload: { loading: true } });

      const eventId = _.get(matchDay, 'model.event.id');
      const { data } = await api.get(`match-day/employees-by-credential`, {
        params: { eventId, credentialNumber: value },
      });

      if (_.size(data) === 0) {
        showMessage('info', `Credencial número ${value}, não foi encontrada!`);
        return false;
      }

      dispatch({
        type: 'matchDay',
        payload: { model: { ...matchDay.model, employee: data } },
      });

      return true;
    } catch (error) {
      failure(error, dispatch);
    } finally {
      dispatch({ type: 'matchDay', payload: { loading: false } });
    }
  };

  const openCovidModal = (modalData) => {
    dispatch({ type: 'matchDay', payload: { modalData, showCovidModal: true }});
  };

  const closeCovidModal = () => {
    dispatch({ type: 'matchDay', payload: { modalData: {}, showCovidModal: false }});
  };

  return {
    state: {
      ...matchDay,
    },
    actions: {
      selectEvent,
      selectEmployee,
      selectCompany,
      isSelectedEvent,
      isSelectedEmployee,
      newEmployee,
      isAddMode,
      eventsFinding,
      employeesFinding,
      companiesFinding,
      saveEmployee,
      searchByCredentialNumber,
      openCovidModal,
      closeCovidModal,
      hasPCovid
    },
  };
};

export default useMatchDay;
